import type { LifecycleStage } from '@/constants/lifecycleStages';

const qtyFmt = new Intl.NumberFormat('vi-VN');

export const formatQty = (n: number | null | undefined): string =>
  n == null || n === 0 ? '—' : qtyFmt.format(n);

/**
 * Build the quantity label for a project's lifecycle stage.
 * Pure function — extracted from ProjectCards for reuse in Card + Table views.
 */
export const buildQuantityLabel = (
  stage: LifecycleStage,
  costDriver: 'hour' | 'm2' | 'both' | null | undefined,
  qHour: number | null | undefined,
  qM2: number | null | undefined
): string => {
  if (stage === 'yet_transferred') return `${formatQty(qHour)} giờ`;
  if (stage === 'warranty' || stage === 'watch') return `${formatQty(qM2)} m²`;
  // maintenance
  if (costDriver === 'hour') return `${formatQty(qHour)} giờ`;
  if (costDriver === 'm2') return `${formatQty(qM2)} m²`;
  if (costDriver === 'both') return `${formatQty(qHour)} giờ / ${formatQty(qM2)} m²`;
  return '—';
};

/**
 * Parse a Postgres interval (string or pg-interval object) into months.
 * Handles: '1 year', '18 mons', '1 year 6 mons', { years, months }, null.
 * Returns null when nothing parseable.
 */
export const parseWarrantyMonths = (
  interval: string | { years?: number; months?: number; days?: number } | null | undefined
): number | null => {
  if (interval == null) return null;
  if (typeof interval === 'object') {
    const y = interval.years ?? 0;
    const m = interval.months ?? 0;
    const total = y * 12 + m;
    return total > 0 ? total : null;
  }
  if (typeof interval === 'string') {
    let total = 0;
    const yearMatch = interval.match(/(\d+)\s*year/i);
    const monMatch = interval.match(/(\d+)\s*mon/i);
    if (yearMatch) total += parseInt(yearMatch[1], 10) * 12;
    if (monMatch) total += parseInt(monMatch[1], 10);
    return total > 0 ? total : null;
  }
  return null;
};
